<script>
    import {derived} from 'svelte/store';

    export let retry = undefined;

    $: {
        if (retry) {
            derived(retry, val => {
                console.log('retry', val);
            })
        }
    }
</script>

<style>
    .outer {
        padding: 15px 15px 30px 15px;
        display: flex;
        justify-content: center;
    }

    .text-center {
        text-align: center;
    }
</style>


{#if retry && $retry}
    <div class="outer">
        <div class="text-center">
            <p>There was an error fetching data</p>
            <button data-action="retryRequest" class="flat flat-secondary" on:click={$retry}>RETRY</button>
        </div>
    </div>
{:else}
    <slot>
    </slot>
{/if}